import useTranslation from '../useTranslation';

export default function useGenderOptions() {
  const translate = useTranslation();

  return [
    { key: 'male', label: translate('form.gender_male') },
    { key: 'female', label: translate('form.gender_female') },
    { key: '', label: translate('form.gender_dont_want_to_say') },
  ];
}
